import React, { useState, forwardRef, useImperativeHandle, Fragment } from "react";
import AppModal from "component/Modal/AppModal";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { AccordionBody, AccordionHeader, AccordionItem, Col, Row, UncontrolledAccordion } from "reactstrap";
import FormInput from "component/FormControl/FormInput";
import { useDispatch, useSelector } from "react-redux";
import { addAdminSwitchAccount, adminSwitchableAcc, removeAdminSwitchAcc, switchAdminAcc } from "store/actions";
import AppButton from "component/Buttons/AppButton";
import Drawer from "component/Drawer/Drawer";
import DeleteModal from "components/Common/DeleteModal";
import AdminLoginForm from "pages/Authentication/Forms/AdminLoginForm";
import VerificationForm from "pages/Authentication/Forms/VerificationForm";
import { me } from "constants/Client";
import MyToolTip from "component/ToolTip/ToolTip";
import { useHistory } from "react-router-dom";

const SwitchAccount = ({}, ref) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const apiHeader = { switch_token: me()?.switch_token, user_token: me()?.user_token };

  const isValid = me()?.user_token && me()?.switch_token ? false : true;
  const [loginModal, setLoginModal] = useState(false);
  const [delModal, setDelModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [record, setRecord] = useState();
  const [warning, setwarning] = useState(false);

  const twarning = () => {
    setwarning(!warning);
  };

  const { accounts } = useSelector(state => ({
    accounts: state.Admins.switchAccs,
  }));

  const syncList = () => {
    dispatch(
      adminSwitchableAcc(
        {},
        () => {},
        () => {},
        apiHeader
      )
    );
  };

  const toggle = () => {
    if (isValid) {
      setwarning(true);
      return;
    }
    if (!isOpen) {
      syncList();
      setRecord();
      setLoading(false);
      setIsLogin(true);
    }
    setIsOpen(!isOpen);
  };

  useImperativeHandle(ref, () => ({ toggle }));

  const tLoginModal = () => {
    if (!loginModal) setIsLogin(true);
    setLoginModal(!loginModal);
  };

  const onDelete = agrs => {
    setRecord(agrs?.admin_switch_account_id);
    setDelModal(true);
  };

  const onDeleting = () => {
    setLoading(true);
    dispatch(
      removeAdminSwitchAcc(
        { admin_switch_account_id: record },
        () => {
          setLoading(false);
          syncList();
          setDelModal(false);
          setRecord();
        },
        () => {
          setLoading(false);
        }
      )
    );
  };

  const onLoginSuccess = _ => {
    // setIsLogin(false);
    if (_?.email_sent_to) {
      localStorage.setItem(
        "loginData",
        JSON.stringify({
          email: _.email_sent_to,
          ..._,
        })
      );
      setIsLogin(false);
    } else {
      syncList();
      tLoginModal();
    }
  };

  const onVerifySuccess = () => {
    syncList();
    tLoginModal();
  };

  const onOk = () => {
    setwarning(false);
    history?.push("/logout");
  };

  return (
    <Fragment>
      <Drawer isOpen={isOpen} onToggle={toggle} title='Switch Account'>
        {isValid && <div className='text-center py-3 text-danger fw-bold'>Please re-login and refresh to use this feature</div>}
        <Row style={{ maxWidth: "450px" }}>
          {!localStorage.getItem("switchedSTA") && (
            <Col md={12}>
              <h6 className='text-muted'>You can add more account.</h6>
              <AppButton disabled={isValid} size='sm' label='Add Account' prefixIcon={<i className='mdi mdi-account-plus-outline' />} onClick={tLoginModal} />
              <hr className='mt-4 mb-3' />
            </Col>
          )}
          <Col md={12}>
            <h6 className='text-muted'> Switch Account</h6>
            <Formik
              initialValues={
                {
                  // admin_switch_account_id: {},
                }
              }
              onSubmit={(values, { setSubmitting }) => {
                dispatch(
                  switchAdminAcc(
                    { admin_switch_account_id: values.admin_switch_account_id.value },
                    response => {
                      let user = JSON.parse(localStorage.getItem("authUser"));
                      user["user_token"] = response?.user_token;
                      localStorage.setItem("authUser", JSON.stringify(user));
                      localStorage.setItem("uid", JSON.stringify(response?.user_token));
                      if (localStorage.getItem("switchedSTA")) {
                        localStorage.removeItem("switchedSTA", "true");
                      } else {
                        localStorage.setItem("switchedATS", "true");
                      }
                      setSubmitting(false);
                      window.location.href = "/";
                    },
                    () => {
                      setSubmitting(false);
                    },
                    apiHeader
                  )
                );
              }}>
              {({ setFieldValue, submitForm }) => {
                return (
                  <Form>
                    <Row>
                      <Col md={12}>
                        {accounts?.employees?.length > 0 && <h6 className='text-muted'>Employees</h6>}
                        {accounts?.employees?.map((_, key) => {
                          return (
                            <div key={key} className='border border-3 mb-2 rounded p-2 px-4 vh-center justify-content-between'>
                              <span className='text-dark ms-2'>{_?.emp_name}</span>
                              {!isValid && (
                                <MyToolTip heading='Switch'>
                                  <i
                                    role='button'
                                    className='mdi mdi-account-convert text-primary font-size-18 me-2'
                                    onClick={() => {
                                      setFieldValue("admin_switch_account_id", { label: _?.emp_name, value: _?.admin_switch_account_id });
                                      submitForm();
                                    }}
                                  />
                                </MyToolTip>
                              )}
                            </div>
                          );
                        })}
                        {accounts?.suport_worker?.length > 0 && <h6 className='text-muted mt-3'>Support Worker</h6>}
                        {accounts?.suport_worker?.map((_, key) => {
                          return (
                            <div key={key} className='border border-3 mb-2 rounded p-2 px-4 vh-center justify-content-between'>
                              <span className='text-dark ms-2'>{_?.emp_name}</span>
                              {!isValid && (
                                <MyToolTip heading='Switch'>
                                  <i
                                    role='button'
                                    className='mdi mdi-account-convert text-primary font-size-18 me-2'
                                    onClick={() => {
                                      setFieldValue("admin_switch_account_id", { label: _?.emp_name, value: _?.admin_switch_account_id });
                                      submitForm();
                                    }}
                                  />
                                </MyToolTip>
                              )}
                            </div>
                          );
                        })}
                      </Col>
                    </Row>
                  </Form>
                );
              }}
            </Formik>
          </Col>
          <Col md={12}>
            <hr className='mt-4 mb-3' />
            <UncontrolledAccordion>
              <AccordionItem>
                <AccordionHeader targetId='1' className='remove-accordion-arrow'>
                  <h6 className='text-danger m-0'>Remove account</h6>
                </AccordionHeader>
                <AccordionBody accordionId='1'>
                  <Formik
                    initialValues={
                      {
                        // admin_switch_account_id: {},
                      }
                    }
                    // validationSchema={Yup.object().shape({
                    //   admin_switch_account_id: Yup.object().shape({
                    //     label: Yup.string().required('Required'),
                    //     value: Yup.string().required('Required'),
                    //   }).nullable().required('Required'),
                    // })}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      dispatch(
                        removeAdminSwitchAcc(
                          { admin_switch_account_id: values.admin_switch_account_id.value },
                          () => {
                            setSubmitting(false);
                            resetForm({ values: { admin_switch_account_id: {} } });
                            syncList();
                            setDelModal(false);
                            setRecord();
                          },
                          () => {
                            setSubmitting(false);
                          }
                        )
                      );
                    }}>
                    {({ isSubmitting, submitForm, values }) => {
                      return (
                        <Form>
                          <div className='d-flex gap-3 align-items-end'>
                            <div className='flex-grow-1'>
                              <FormInput
                                type='multi-select'
                                label='Account'
                                name='admin_switch_account_id'
                                inputProps={{ disabled: isValid, isMulti: false, isClearable: false, closeMenuOnSelect: true }}
                                options={[
                                  {
                                    label: "Employees",
                                    options: accounts?.employees?.map(_ => ({ label: _?.emp_name, value: _?.admin_switch_account_id })),
                                  },
                                  {
                                    label: "Support Workers",
                                    options: accounts?.suport_worker?.map(_ => ({ label: _?.emp_name, value: _?.admin_switch_account_id })),
                                  },
                                ]}
                              />
                            </div>
                            <AppButton
                              onClick={() => setDelModal(true)}
                              disabled={isValid || !values?.admin_switch_account_id?.value}
                              label='Remove'
                              isSubmitting={isSubmitting}
                              outline
                              size='sm'
                              color='danger'
                              prefixIcon={<i className='mdi mdi-account-remove-outline text-danger' />}
                            />
                          </div>
                          <DeleteModal
                            show={delModal}
                            label='Yes, Remove it!'
                            loading={loading}
                            onDeleteClick={submitForm}
                            onCloseClick={() => setDelModal(!delModal)}
                          />
                        </Form>
                      );
                    }}
                  </Formik>
                </AccordionBody>
              </AccordionItem>
            </UncontrolledAccordion>
          </Col>
        </Row>
      </Drawer>

      <AppModal isOpen={loginModal} onToggle={tLoginModal} title='Verify Account Details'>
        {isLogin ? (
          <AdminLoginForm apiHeader={apiHeader} onSuccess={onLoginSuccess} />
        ) : (
          <VerificationForm switchLogin apiHeader={apiHeader} onSuccess={onVerifySuccess} />
        )}
      </AppModal>

      <AppModal isOpen={warning} onToggle={twarning} title=''>
        <div className='text-center'>
          <i className='mdi mdi-alert-circle-outline text-warning' style={{ fontSize: "6em" }} />

          <h5 className='fw-bold mb-3'>Please logout and login again to use this feature.</h5>
          <div className='vh-center gap-2'>
            <AppButton onClick={twarning} color='danger' outline label={"Cancel"} />
            <AppButton onClick={onOk} color='primary' label={"Logout"} />
          </div>
        </div>
      </AppModal>
    </Fragment>
  );
};

export default forwardRef(SwitchAccount);
